<div class="h3">Verzekering eerder be&euml;indigen</div>
<p>Kies hieronder de eerste dag waarop u niet meer verzekerd wilt zijn. Dat kan vanaf morgen.</p>
<p>Wij zorgen ervoor dat u de eventueel vooruitbetaalde premie weer netjes terug krijgt op uw bankrekening.</p>
<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label>Einddatum</wuc-form-field-label>
        <wuc-input-date-picker
            formControlName="endDate"
            [selectPastDates]="false"
            [selectToday]="false"
        ></wuc-input-date-picker>
        <wuc-input-alert *ngIf="endDate.touched && endDate.hasError('required')">Vul uw einddatum in.</wuc-input-alert>
    </wuc-form-field>
    <p *ngIf="errors?.length">
        <wuc-card cardStyle="tertiary" padding="medium">
            <wuc-list icon="cross">
                <wuc-list-item *ngFor="let error of errors">{{ error.message }}</wuc-list-item>
            </wuc-list>
        </wuc-card>
    </p>
    <wuc-form-field>
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button [isSubmitButton]="true" [disabled]="isDisabled" [isFullWidth]="true">Ja, dit wordt 'm</wuc-button>
    </wuc-form-field>
</form>
